import {FC} from 'react';
import {styled} from 'styled-components';

import {ChampionsPool} from '@src/components/champions_pool';
import {TeamSelection} from '@src/components/team_selection';
import {Team} from '@src/lib/teams';

interface TeamModuleProps {
  team: Team;
}

export const TeamModule: FC<TeamModuleProps> = props => {
  const {team} = props;
  return (
    <Wrapper>
      <TeamSelection team={team} />
      <ChampionsPool team={team} />
    </Wrapper>
  );
};

TeamModule.displayName = 'TeamList';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
